module.exports = __webpack_public_path__ + "static/icons/icon-caret-right-d8e60f359204b0b66a5ff6feb291984f.svg";